import type { MutableRefObject } from 'react';

const transformNames = [
  'transform',
  'WebkitTransform',
  'msTransform',
  'MozTransform',
  'OTransform',
];

/**
 *
 * @description 兼容各种浏览器的 transform
 */
export function setTransformStyle(value: string): object {
  const style: { [key: string]: string } = {};
  transformNames.forEach((name) => {
    style[name] = value;
  });
  return style;
}

export function getWidthTabList(list: HTMLCollection) {
  return Array.prototype.map.bind(list, item => item.clientWidth)() as number[];
}

export function getMinHeaderOffset(containerRef: MutableRefObject<HTMLElement | null>, wrapperRef: MutableRefObject<HTMLElement | null>, additionalScrollWidth = 4) {
  const containerWidth = containerRef?.current?.clientWidth || 0;
  const wrapperWidth = wrapperRef?.current?.clientWidth || 0;
  return wrapperWidth - containerWidth - additionalScrollWidth;
}

/**
 * 计算子元素相对于父元素的左右偏移量
 * @param node 子元素节点
 * @param parentNode 父元素节点
 * @returns 返回相对于父元素的左右偏移量，考虑了缩放比例
 */
export function getRectDiff(node: HTMLElement, parentNode: HTMLElement) {
  const nodeRect = node.getBoundingClientRect();
  const parentRect = parentNode.getBoundingClientRect();
  const scaleX = parentNode.offsetWidth / parentRect.width;

  return {
    left: (nodeRect.left - parentRect.left) * scaleX,
    right: (nodeRect.right - parentRect.right) * scaleX,
  };
}
